var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75621 20V10.8919H9.83633L10.2942 7.32578H6.75621V5.05432C6.75621 4.02527 7.04362 3.32071 8.52408 3.32071H10.4V0.141321C9.48726 0.0437405 8.5698 -0.0033761 7.65184 0.000187992C4.92931 0.000187992 3.06007 1.65823 3.06007 4.70204V7.31912H0V10.8852H3.06675V20H6.75621Z",
    fill: "#0D1117",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.3cd4e202830ee4e9a233363b6e9a32a6.svg";
export { ForwardRef as ReactComponent };